import React, { createContext, useContext, useState, useMemo } from "react";
import { translations } from "@/lib/i18n";

const LangContext = createContext({ lang: "es", setLang: () => {}, t: translations.es });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("riocode_lang") || "es";
    }
    return "es";
  });

  const value = useMemo(() => {
    const setLangPersist = (l) => {
      setLang(l);
      if (typeof window !== "undefined") localStorage.setItem("riocode_lang", l);
    };
    return { lang, setLang: setLangPersist, t: translations[lang] };
  }, [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
